module.exports = __webpack_public_path__ + "img/mii.afe27cbc.png";